import { z } from "zod";
import type { components, operations } from "../generated/public-contact.openapi";

export type PublicContactSubmitRequest = components["schemas"]["StoreContactRequest"];
export type PublicContactSubmitResponse =
    operations["publicContact.store"]["responses"][201]["content"]["application/json"];
export type PublicContactValidationErrorResponse =
    operations["publicContact.store"]["responses"][422]["content"]["application/json"];

export const PublicContactSubmitRequestSchema: z.ZodType<PublicContactSubmitRequest> = z.object({
    email: z.email().max(255),
    first_name: z.string().min(1).max(255),
    last_name: z.string().min(1).max(255),
    body: z.string().min(1).max(65535),
});

export const PublicContactSubmitResponseSchema: z.ZodType<PublicContactSubmitResponse> = z.object({
    success: z.boolean(),
    message: z.literal("Your message has been sent. We’ll get back to you soon."),
});

export const PublicContactValidationErrorResponseSchema: z.ZodType<PublicContactValidationErrorResponse> = z.object({
    message: z.string(),
    errors: z.record(z.string(), z.array(z.string())),
});
